import apiService from 'src/shared/config/apiService';
import { BulkOrdering } from 'src/shared/types/bulkOrdering';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

const getBulkOrdering = async (orderId: string): Promise<BulkOrdering> => {
  try {
    const response = await apiService.get(`/bulk_orderings/${orderId}/`);

    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getBulkOrdering;
